import React from 'react';
import PropTypes from 'prop-types';

const InputPolicyList = props => {
  const { rules, value, label } = props;
  return (
    <div>
      {rules.length > 0 && (
        <div className="input-policy--content">
          <p className="input-policy--header">{label} must:</p>
          <ul className="input-policy--terms-list">
            {rules.map((rule, index) => (
              <li
                key={`input-policy--term-${index}`}
                className={`input-policy--term ${rule.regex.test(value) ? 'valid' : 'invalid'}`}
              >
                <span className="input-policy--term-text">{rule.text}</span>
              </li>
            ))}
          </ul>
          <style>{`
        .input-policy--header {
          font-size: 13px;
          line-height: 17px;
          text-transform: uppercase;
          letter-spacing: 1px;
          margin-bottom: 12px;
          color: rgba(0,0,0,0.86);
          font-weight: 500;
        }
        .input-policy--term {
          line-height: 20px;
          font-size: 20px;
          margin-top: 8px;
        }
       .input-policy--term.invalid {
          color: #E3E5E7;
        }
        .input-policy--term.valid {
          color: #01B48F;
        }
        .input-policy--term .input-policy--term-text {
          font-size: 14px;
          vertical-align: bottom;
          color: rgba(0,0,0,0.53);
        }
       `}</style>
        </div>
      )}
    </div>
  );
};

InputPolicyList.propTypes = {
  rules: PropTypes.array.isRequired,
  value: PropTypes.string,
  label: PropTypes.string
};

InputPolicyList.defaultProps = {
  rules: [],
  value: '',
  label: 'Input'
};

export default InputPolicyList;



// WEBPACK FOOTER //
// ./src/modules/signupForm/ab-show-password-policy/components/InputPolicy/InputPolicy.js